import { useState, useEffect, useCallback, useRef } from 'react';
import { InterviewStatus, InterviewStatusResponse } from '@recruitai/shared';
import { apiClient } from '../lib/api-client';

export function useInterviewStatus(
  jobId: string,
  candidateId: string,
  interviewId: string,
  enabled: boolean
) {
  const [status, setStatus] = useState<InterviewStatus>(InterviewStatus.PENDING);
  const [isPolling, setIsPolling] = useState(false);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const checkStatus = useCallback(async () => {
    if (!jobId || !candidateId || !interviewId) return;
    try {
      const response = await apiClient.get<InterviewStatusResponse>(
        `/jobs/${jobId}/candidates/${candidateId}/interviews/${interviewId}/status`
      );
      setStatus(response.status);

      // Parar polling se concluído ou pendente
      if (response.status === InterviewStatus.DONE || response.status === InterviewStatus.PENDING) {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
          setIsPolling(false);
        }
      }
    } catch {
      // Silencioso no polling
    }
  }, [jobId, candidateId, interviewId]);

  useEffect(() => {
    if (enabled && !intervalRef.current) {
      setIsPolling(true);
      checkStatus(); // Primeira verificação imediata
      intervalRef.current = setInterval(checkStatus, 10000);
    }

    if (!enabled && intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
      setIsPolling(false);
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [enabled, checkStatus]);

  return { status, isPolling };
}
